import { z } from 'zod';

export enum DealGroupsSearchKey {
  SEARCH = 'searchFilter',
}

export const dealGroupsRouterSearchParamsSchema = z.object({
  [DealGroupsSearchKey.SEARCH]: z.string().optional(),
});
